import { Component } from 'react';
import { withTranslation } from 'react-i18next';

class WaitMessage extends Component {
    render() {
        return (
            <div className="loaderWaitMessage">
                <div className="loaderWrapper">
                    <div className="spinner"></div>
                    <div className="message">
                        <p>{this.props.t('waitMessage.waitText')}</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation('common')(WaitMessage);
